var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.items.length > 0)?_c('div',{staticClass:"C-block-type-14"},[(_vm.settings.type === 'grid')?_c('BlockType14Grid',{attrs:{"data":_vm.data,"settings":_vm.settings}}):_c('BlockType14List',{attrs:{"data":_vm.data,"settings":_vm.settings}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }